import React, { useState } from "react";
import api from "./api";
import "./Login.css"; // używamy tych samych stylów co login

const Register = ({ onSwitchToLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");

    const handleRegister = async (e) => {
        e.preventDefault();

        try {
            const res = await api.post("/register.php", { email, password });
            setMessage(res.data.message || res.data.error);
        } catch (err) {
            console.error(err);
            setMessage("Błąd rejestracji");
        }
    };

    return (
        <div className="login-page">
            <div className="login-box">
                <h2>Rejestracja</h2>
                <p className="subtitle">Utwórz nowe konto</p>

                <form onSubmit={handleRegister}>
                    <input
                        type="email"
                        placeholder="Adres e-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <input
                        type="password"
                        placeholder="Hasło"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <button type="submit">Zarejestruj się</button>
                </form>

                {message && <p className="message">{message}</p>}

                <p className="register-link">
                    Masz już konto?{" "}
                    <span onClick={onSwitchToLogin}>
                        Zaloguj się
                    </span>
                </p>
            </div>
        </div>
    );
};

export default Register;